<template>
  <div class="py-4 px-12 mx-4">
    <div class="d-flex align-center mt-6 mb-12 justify-space-between">
      <div class="secondary--text custom-heading mr-12">
        Case File
      </div>
      <div class="d-flex align-center">
        <i
          class="icofont-home icofont-2x mr-4"
          style="color: #C3D1D2;"
        />
        <div
          class="spaced-text secondary--text"
          style="font-size: 1.2rem"
        >
          {{ typeof currentCase.property.streetAddress !== "undefined" && currentCase.property.streetAddress.toUpperCase() }}
        </div>
      </div>
    </div>

    <SubTopNav :value="0" />
  
    <v-container
      fluid
      class="case-view"
    >
      <v-row>
        <v-col 
          class="pl-6 pt-0 flex-grow-1 flex-shrink-0"
          cols="9"
        >
          <!-- <v-col class="pl-6 pt-0"> -->
          <v-row class="mb-6">
            <!-- <v-col cols="4">
                <client-info-card :clientId="currentCase.clientId"/>
            </v-col> -->
            <v-col>
              <case-overview-card :current-case="currentCase" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <doc-list-card 
                title="Uploads"
                :documents="currentCase.documents"
              />
            </v-col>
            <v-col>
              <doc-list-card
                title="Pleadings"
                :documents="pleadingDocuments"
              />
            </v-col>
          </v-row>
          <!-- <PageNavBar :caseId="currentCase.id"/> -->
          <router-view />
        </v-col>
        <v-col 
          class="flex-grow-0 flex-shrink-1"
          cols="3"
        >
          <div>
            <next-step />
            <!-- <timeline /> -->
            <order-details-card :date="currentCase.statusDate" />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- <InfoBar :items="items"/> -->
    <!-- <nav-bottom :value="0" /> -->
  </div>
</template>

<script>
//import InfoBar from "@/components/InfoBar";
// import PageNavBar from '@/components/PageNavBar';
import NextStep from '@/components/NextStep'
// import Timeline from '@/components/Timeline'
// import ClientInfoCard from '@/components/ClientInfoCard'
import CaseOverviewCard from '@/components/CaseOverviewCard'
import DocListCard from '../DocListCard.vue';
import OrderDetailsCard from "../OrderDetailsCard.vue";
// import NavBottom from '../NavBottom.vue'
import SubTopNav from '../SubTopNav.vue'
import { mapGetters } from "vuex"

export default {
  name: 'CaseView',
  components: {
    NextStep,
    // Timeline,
    // PageNavBar,
    // ClientInfoCard,
    CaseOverviewCard,
    DocListCard,
    SubTopNav,
    OrderDetailsCard
  },
  data() {
    return{
      value: 0,
      pleadingDocuments: [
        {
          "filename": "cover_letter.pdf",
          "name": "Cover Letter",
          "created_at": "03.11.20"
        },
        {
          "filename": "verified_complaint.pdf",
          "name": "Verified Complaint",
          templateName: 'verified_complaint_n_landlord_verification',
          "created_at":"03.11.20"
        },
        {
          "filename": "tenant_summons.pdf",
          "name": "Tenant Summons",
          "created_at": "03.11.20"
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentCase: "eviction/currentCase"
    }),
  },
  async created() {
    await this.$store.dispatch("eviction/loadCase", { caseId: this.$route.params.id, logMessage: 'CaseView.vue at line 96' });
    await this.$store.dispatch("eviction/getOrderByCaseId", { caseId: this.$route.params.id, logMessage: 'CaseView.vue at line 96' });
  }
    
}
</script>

<style>
.rounded-card.v-card.v-sheet.theme--light{
    border-radius: 20px;
}
.active-bottom-btn {
    color: white !important;
    background-color: #4DCCC4 !important;
}
</style>
